import {
	SET_IS_LOADING,
	SET_LAYOUT_ZOOM,
	INCREMENT_LAYOUT_ZOOM,
	DECREMENT_LAYOUT_ZOOM,
} from "../constants/Gui";

export const setIsLoading = (isLoading) => {
	return {
		type: SET_IS_LOADING,
		isLoading,
	};
};

export const setLayoutZoom = (payload) => ({
	type: SET_LAYOUT_ZOOM,
	payload,
});

export const incrementLayoutZoom = () => ({
	type: INCREMENT_LAYOUT_ZOOM,
});

export const decrementLayoutZoom = () => ({
	type: DECREMENT_LAYOUT_ZOOM,
});
